import { focusTheme } from '../../utils/focusTheme';

function ActivitySubmittedBanner({ title, description }) {
  return (
    <div className={`flex items-center gap-3 rounded-[10px] px-4 py-3 ${focusTheme.submitted.banner}`}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={focusTheme.submitted.bannerIcon}
      >
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <path d="M22 4L12 14.01l-3-3" />
      </svg>
      <div>
        <p className={`text-[14px] font-bold ${focusTheme.submitted.bannerText}`}>{title}</p>
        <p className="text-[13px] font-medium text-slate-700">{description}</p>
      </div>
    </div>
  );
}

export default ActivitySubmittedBanner;
